import app from '../app.first';
import { each, escape } from 'lodash';

app.SelectedUserDetails = class extends app.Component {
	onReady () {
		this.fetchContent();
		$(document).on('Admin.UserDetails.selectedIds.change', () => this.fetchContent());

		$('.select-all').on('click',() => {
			this.selectAll();
		})

		$('.select-none').on('click',() => {
			this.selectNone();
		})

		this.$el.find('.selected-list').on('click', '.remove', e => this.removeSelected($(e.target).closest('[data-user-detail-id]').data('userDetailId')));
	}

	async selectAll() {
		let result = await app.ajax(
			`/admin/user-details/select-all-users.json`,
			{ selected: true }, false
		);
		this.fetchContent();
		$('input.user-detail-select').prop('checked', true);

	}

	async selectNone() {
		let result = await app.ajax(
			`/admin/user-details/clear-selected-users.json`,
			{ selected: false }, false
		);
		this.fetchContent();
		$('input.user-detail-select').prop('checked', false);
	}

	async removeSelected(userDetailId) {
		let result = await app.ajax(
			`/admin/user-details/select-user/${userDetailId}.json`,
			{ selected: false }, false
		);

		if (result && !result.selected) {
			this.fetchContent();
			$(`.listing [data-user-detail-id="${userDetailId}"]`).removeClass('is-selected')
				.find('input.user-detail-select').prop('checked', false)
		}
	}

	async fetchContent() {
		let result = await app.ajax('/admin/user-details/get-selected-users.json', false, false);

		this.$el.find('.dropdown-button')
			.addClass('have-selected').prop('disabled', false)
			.find('.num-selected').text(result.userDetails.length);

		this.$el.find('.selected-list').empty();
		let items = [];
		each(result.userDetails, user => {
			items.push(`
				<li class="grid-x align-middle" data-user-detail-id="${user.id}">
					<a class="remove">&times;</a>
					&nbsp;&nbsp;&nbsp;
					<span class="cell auto">${escape(user.full_name)}</span>
				</li>
			`);
		});
		this.$el.find('.selected-list').append(items);
	}
}
